import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { iconManager } from './hubPageHelper';
import { computeRankingPhrase } from './clubRankingHelper';
import { useStyles } from './ClubRankProgress.style';
export const ClubRankProgress = ({ rank, nextRank, nextRankRemainingItemsNumber, rankProgression, nextRankRemainingEuros, rankProgressionLimitDate, catchphrase = 'Ma Progression', }) => {
    const classes = useStyles();
    const loadingIcon = iconManager(rank, nextRank, rankProgression);
    return (React.createElement(Box, { sx: classes.rankProgression },
        React.createElement(Box, { sx: classes.rankProgression_leftside }, loadingIcon),
        React.createElement(Box, { sx: classes.rankProgression_rightside },
            React.createElement(Typography, { sx: classes.rs_title }, catchphrase),
            React.createElement(Box, { sx: classes.rs_rankingPhrase }, rank && nextRank
                && computeRankingPhrase(rank, nextRank, nextRankRemainingItemsNumber, nextRankRemainingEuros, rankProgressionLimitDate)))));
};
